module.exports = __webpack_public_path__ + "static/media/plus-box.acc2ab49.svg";